import {createApi} from "@reduxjs/toolkit/query/react"
import {IBasicResponse} from "../../types/api"
import baseQuery from "../../utils/apiIIKOConfig"
import {IBanner} from "./BannerTypes"
import {
    IBannerPayload,
    IBannerTypeResponse,
    IBannersListParams,
    ICreateBannerResponse,
    IDeleteBannerParams,
    IUpdateBannerParams,
    IUploadAttachmentParams,
    IUploadAttachmentResponse
} from "./BannerApiTypes"

export const bannerApi = createApi({
    reducerPath: "bannerApi",
    baseQuery,
    tagTypes: ["banners"],
    endpoints: (build) => ({
        getBanners: build.query<IBasicResponse<IBanner[]>, IBannersListParams>({
            query: () => ({
                url: "/v1/banners",
                method: "GET",
            }),
            providesTags: ["banners"]
        }),
        getBannerTypes: build.query<IBasicResponse<IBannerTypeResponse[]>, void>({
            query: () => ({
                url: "/v1/banners/types",
                method: "GET",
            })
        }),
        createBanner: build.mutation<IBasicResponse<ICreateBannerResponse>, IBannerPayload>({
            query: (body) => ({
                url: "/v1/banners",
                method: "POST",
                body
            }),
            invalidatesTags: ["banners"]
        }),
        updateBannerById: build.mutation<IBasicResponse<void>, IUpdateBannerParams>({
            query: ({id, ...body}) => ({
                url: `/v1/banners/${id}`,
                method: "PUT",
                body
            }),
            invalidatesTags: ["banners"]
        }),
        deleteBannerById: build.mutation<IBasicResponse<void>, IDeleteBannerParams>({
            query: ({id}) => ({
                url: `/v1/banners/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["banners"]
        }),
        uploadAttachment: build.mutation<IBasicResponse<IUploadAttachmentResponse>, IUploadAttachmentParams>({
            query: ({file}) => {
                const formData = new FormData()
                formData.append("file", file)
                return {
                    url: "/v1/attachments",
                    method: "POST",
                    body: formData
                }
            }
        })
    })
})

export const {
    useGetBannersQuery,
    useGetBannerTypesQuery,
    useCreateBannerMutation,
    useUpdateBannerByIdMutation,
    useDeleteBannerByIdMutation,
    useUploadAttachmentMutation
} = bannerApi
